import TextField from "../Reusable/TextInput";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import APIS from "../../constant/EndPoint";
import usePostHook from "../../customHooks/usePostHook";
import { branchValidationForm } from "../../utils/validationSchemas";
import Button from "../Reusable/Button";
import PhoneNumberField from "../Reusable/PhoneNumberField";
const CreateBranchForm = (props: any) => {
  const { openBranchformPopup, setIsOpenBranchformPopup, userProfile } = props;
  const {
    register,
    formState: { errors },
    getValues,
    setValue,
    clearErrors,
    handleSubmit,
    setError,
    watch,
    control,
  } = useForm<any>({
    resolver: yupResolver(branchValidationForm),
  });
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["branch"],
    navigateURL: "",
  });
  const handleCreate = async (values: any, setError: any) => {
    let formData = {
      ...values,
      covered_city:
        values?.covered_city && values?.covered_city.length > 0
          ? values.covered_city.map((item: any) => item.value)
          : [],
      ...(values?.service_branch && values?.service_branch.length > 0
        ? {
            service_branch: values.service_branch.map(
              (item: any) => item.value
            ),
          }
        : {}),
    };
    const url = APIS.CREATE_BRANCH;
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 201) {
        setIsOpenBranchformPopup(!openBranchformPopup);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const TypeData = [
    {
      name: "flat",
      id: "flat",
    },
    {
      name: "percentage",
      id: "percentage",
    },
  ];

  return (
    <>
      <form
        onSubmit={handleSubmit((data: any) => handleCreate(data, setError))}
      >
        <div className={tw`flex w-full gap-x-4 px-4`}>
          <div className={tw`w-full`}>
            <TextField
              label={"Branch Name"}
              register={register("name")}
              errors={errors?.name}
            />
            <TextField
              label={"Code"}
              register={register("code")}
              errors={errors?.code}
            />
            <TextField
              label={"Company Name"}
              register={register("company_name")}
              errors={errors?.company_name}
            />
            <TextField
              label={"VAT/PAN"}
              register={register("vat_pan")}
              errors={errors?.vat_pan}
            />
          </div>
          <div className={tw`w-full`}>
            <TextField
              label={"Email"}
              register={register("primary_email")}
              errors={errors?.primary_email}
            />
            <PhoneNumberField
              control={control}
              label={"Primary Phone"}
              name={"primary_contact"}
              errors={errors?.primary_contact}
            />
            <PhoneNumberField
              control={control}
              label={"Secondary Contact"}
              name={"secondary_contact"}
              errors={errors?.secondary_contact}
            />
            <TextField
              label={"Full Address"}
              register={register("landmark")}
              errors={errors?.landmark}
            />
            {/* <MultipleSelectField
              label={"Covered City"}
              queryKey={"covered-city"}
              register={register("covered_city")}
              watch={watch}
              setValue={setValue}
              url={`${APIS.LOCATION}flat-location/`}
              errors={errors.covered_city}
              value={[]}
              props={{
                level: 3,
                is_active: true,
              }}
            /> */}
          </div>
        </div>
        <div className={tw`flex justify-end w-full px-4`}>
          <div className={tw`w-24`}>
            <Button
              label={"Create"}
              isLoading={isPostLoading}
              // disabled={!userProfile?.is_superuser}
            />
          </div>
        </div>
      </form>
    </>
  );
};

export default CreateBranchForm;
